<template>
  <div class="container main-content">
    <h1>Neue Voralge erstellen</h1>
    <b-form @submit="onSubmit">
      <b-form-group
        id="input-group-1"
        label="Name der Vorlage"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="proposal.name"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Kurzbeschreibung:" label-for="input-2">
        <b-form-textarea
          id="input-2"
          v-model="proposal.shortDescription"
          required
          rows="5"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group id="input-group-3" label="Inhalt:" label-for="input-3">
        <b-form-textarea
          id="input-3"
          v-model="proposal.content"
          required
          rows="8"
          max-rows="20"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group id="input-group-4" label="Abstimmungsdatum:" label-for="input-4">
        <b-form-input
          id="input-4"
          v-model="proposal.effectiveDate"
          type="date"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-5" label="Link:" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="proposal.Link"
          type="url"
          required
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" class="mr-2">Speichern</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'Create',
  data() {
    return {
      proposal: {
        name: '',
        shortDescription: '',
        content: '',
        effectiveDate: '',
        Link: '',
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$bvToast.toast('Vorlage erstellt', {
        title: 'Bestätigung',
        autoHideDelay: 5000,
      });
      this.$router.push({ name: 'proposalList' });
    },
  },
};
</script>
